import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import styles from './gradientMask.module.scss';

const TABLET_MD_AND_UP = 768;
export default function GradientMask({
  maskType = 'linear',
  maskDirection = 'left',
  maskTheme = 'white',
  disableOnMobile = false,
}) {
  const { width } = useWindowDimensions();
  const [maskDisabled, setMaskDisabled] = useState(false);

  const setVisibility = useCallback(() => {
    setMaskDisabled(false);
    if (width < TABLET_MD_AND_UP && disableOnMobile) {
      setMaskDisabled(true);
    }
  }, [width, disableOnMobile]);

  useEffect(() => {
    setVisibility();
  }, [setVisibility]);

  const classMaskDirection = styles[maskDirection];
  const classMaskTheme = styles[maskTheme];
  const maskerClass = `${styles.gradientMask} ${styles[maskType]} ${classMaskDirection} ${classMaskTheme}`;
  return classMaskTheme && !maskDisabled ? (
    <div className={maskerClass} />
  ) : null;
}

GradientMask.propTypes = {
  maskType: PropTypes.oneOf(['linear', 'radial']),
  maskDirection: PropTypes.oneOf(['left', 'right']),
  maskTheme: PropTypes.oneOf([
    null,
    'black',
    'white',
    'green',
    'cardinal',
    'denim',
    'sapphire',
    'sky',
    'avocado',
    'stainless',
  ]),
  disableOnMobile: PropTypes.bool,
};
